import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet';

const HtmlTitle = ({ title }: { title: string }): ReactNode => (
  <Helmet>
    <title>{title} | HYROX365 Performance Hub</title>
  </Helmet>
);

export default HtmlTitle;
